import { h } from 'preact'
import { errorIcon } from '../../shared/svgIcons'
import { StepBody } from '../step-body'
import { StepFooter } from '../step-footer'

import * as style from './style.css'

function UnavailableWidget() {
    return (
        <section class={style.unavailableWidgetContainer}>
            <StepBody>
                <div class={style.unavailableWidget}>
                    {errorIcon()}
                    <div class={style.unavailableWidgetText}>
                        This page is currently unavailable. Please try again later.
                    </div>
                </div>
            </StepBody>
            <StepFooter onNext={() => {}} isNextDisabled={true} />
        </section>
    )
}

export default UnavailableWidget
